import api from '../../apiConfig/apiConfig';
import { Get, Post, Put } from '../base/baseAjax';

let addAccount = function (param) {
	return Post({
		url: api.account.addAccount,
		bodyParam: param,
	});
};
let editAccount = function (param) {
	return Put({
		url: api.account.addAccount,
		bodyParam: param,
	});
};
let getAuthUrl = function (param) {
	return Post({
		url: api.account.getAuthUrl,
		bodyParam: param,
	});
};
let getPlatFormAccount = param => {
	return Post({
		url: api.account.getPlatFormAccount,
		UrlParam: param,
	});
};
export function getGaList(param) {
	return Get({
		url: api.account.getGaList,
		UrlParam: param,
	});
}
export function gtmaccount(param) {
	return Get({
		url: api.account.gtmaccount,
		UrlParam: param,
	});
}
export function getBdList(param) {
	return Post({
		url: api.account.getBdList,
		bodyParam: param,
	});
}
export function googleaccount() {
	return Get({
		url: api.account.googleaccount,
		config: {
			timeout: 60000,
		},
	});
}
export default {
	getPlatFormAccount,
	addAccount,
	editAccount,
	getAuthUrl,
	getGaList,
	getBdList,
	googleaccount,
	gtmaccount,
};
